import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

// antd stores a rule's error message as the string t() produced when validation ran, so errors
// already on screen stay in the old language after the English/Spanish toggle. Re-validating
// just the fields currently showing an error regenerates them from the (re-rendered) rules in
// the new language, without surfacing errors on fields the customer hasn't touched.
const useRevalidateOnLanguageChange = (form) => {
  const { i18n } = useTranslation();
  const previousLanguage = useRef(i18n.language);

  useEffect(() => {
    if (previousLanguage.current === i18n.language) {return;}
    previousLanguage.current = i18n.language;

    const fieldsWithErrors = form
      .getFieldsError()
      .filter(({ errors }) => errors.length > 0)
      .map(({ name }) => name);
    if (fieldsWithErrors.length > 0) {
      form.validateFields(fieldsWithErrors).catch(() => {});
    }
  }, [i18n.language, form]);
};

export default useRevalidateOnLanguageChange;
